import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo_creatale.svg'


const _withScopeId = n => (_pushScopeId("data-v-1c9c7cb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mainMenu" }
const _hoisted_2 = { class: "navigation" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "creatale-Logo"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headline = _resolveComponent("headline")!
  const _component_navigation_button = _resolveComponent("navigation-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_headline, { title: "Christmas PiX" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_navigation_button, {
        title: "Start",
        navigateTo: "/levels"
      }),
      _createVNode(_component_navigation_button, {
        title: "Anleitung",
        navigateTo: "/how-to-play"
      }),
      _createVNode(_component_navigation_button, {
        title: "Datenschutz",
        navigateTo: "/privacy"
      }),
      (_ctx.sharingEnabled)
        ? (_openBlock(), _createBlock(_component_navigation_button, {
            key: 0,
            title: "Teilen",
            onClick: _ctx.onShare
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_3
  ]))
}